import * as Yup from 'yup'

const menuFormatAndNoScrapeableReasonSchema = Yup.object().shape({
  url: Yup.string()
    // .url('Menu URL is not valid')
    .required('Menu format is required'),
})

export default menuFormatAndNoScrapeableReasonSchema
